module.exports = __webpack_public_path__ + "static/media/Hair_1_blue.d78a347f.svg";